// import { Validator } from 'vee-validate'

export default function install() {
}
